import React, { useEffect, useRef, useState } from "react";
import "./Testimonials.css";

import image1 from "../Images/mehta.png";
import image2 from "../Images/sophia.png";
import daniel from "../Images/daniel.png";
import image4 from "../Images/priya.png";
import image5 from "../Images/liam.png";
import maya from "../Images/maya.png";
import patel from "../Images/patel.png";

const testimonialsData = [
  {
    quote: "The process was smoother than I ever imagined. They took care of everything while I focused on growing my business.",
    name: "Aarav Mehta",
    role: "Tech Entrepreneur",
    rating: 5,
    avatar: image1,
  },
  {
    quote: "I didn't just file my taxes—I learned how to save smarter and plan better.",
    name: "Sophia Williams",
    role: "Freelance Developer",
    rating: 5,
    avatar: image2,
  },
  {
    quote: "Professional, reliable, and incredibly efficient. Their team handled my complex multi-state tax situation with expertise.",
    name: "Daniel Thompson",
    role: "Business Consultant",
    rating: 5,
    avatar: daniel,
  },
  {
    quote: "Their personalized guidance gave me peace of mind during a stressful audit process.",
    name: "Priya Sharma",
    role: "Senior Software Engineer",
    rating: 5,
    avatar: image4,
  },
  {
    quote: "They simplified my business taxes and identified deductions I didn't know existed.",
    name: "Liam Anderson",
    role: "Professional Photographer",
    rating: 5,
    avatar: image5,
  },
  {
    quote: "I saved more than 40% compared to my previous tax preparer thanks to their expert planning.",
    name: "Maya Fernandez",
    role: "Startup Founder",
    rating: 5,
    avatar: maya,
  },
  {
    quote: "They turned a complicated international tax situation into a seamless experience.",
    name: "Ethan Patel",
    role: "Small Business Owner",
    rating: 5,
    avatar: patel,
  },
];

const Testimonials = () => {
  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (!isMobile) return;

    const scrollContainer = scrollRef.current;
    const autoScroll = () => {
      if (scrollContainer && !isPaused) {
        scrollContainer.scrollLeft += 1;
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
          scrollContainer.scrollLeft = 0;
        }
      }
    };
    const interval = setInterval(autoScroll, 25);
    return () => clearInterval(interval);
  }, [isPaused, isMobile]);

  const renderStars = (rating) =>
    Array.from({ length: 5 }).map((_, i) => (
      <span key={i} className={`star ${i < rating ? "filled" : ""}`}>
        ★
      </span>
    ));

  return (
    <section className="testimonials-section">
      <div className="testimonials-header">
        <h2>
          What Our <span>Clients Say</span>
        </h2>
        <p>
          Real stories from individuals and businesses who've trusted us with
          their finances.
        </p>
      </div>

      {/* Desktop Grid */}
      <div className="testimonials-grid">
        {testimonialsData.map((t, i) => (
          <div key={i} className="testimonial-card">
            <div className="avatar">
              <img src={t.avatar} alt={t.name} />
            </div>
            <blockquote>"{t.quote}"</blockquote>
            <div className="user-info">
              <h4>{t.name}</h4>
              <p>{t.role}</p>
              <div className="rating">{renderStars(t.rating)}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Mobile & Tablet Carousel */}
      <div
        className="testimonials-carousel"
        ref={scrollRef}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        onTouchStart={() => setIsPaused(true)}
        onTouchEnd={() => setIsPaused(false)}
      >
        {[...testimonialsData, ...testimonialsData].map((t, i) => (
          <div key={i} className="testimonial-slide">
            <div className="avatar">
              <img src={t.avatar} alt={t.name} />
            </div>
            <blockquote>"{t.quote}"</blockquote>
            <div className="user-info">
              <h4>{t.name}</h4>
              <p>{t.role}</p>
              <div className="rating">{renderStars(t.rating)}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;